import { APIBlock, APIDeployment, APIProject, APIBackup } from "@/typesAPI"
import helpers from '@/utils/helpers'
import enums from "@/enums"
import API from "@/api/wrapper"

type State = {
  list: APIBlock[],
  listByRelease: {[key:string]: APIBlock[]},
  projectListByRelease: {[key:string]: APIProject[]},
  deploymentList:APIDeployment[],
  backupListByBlockID: {[key:string]: APIBackup[]},
  lastBackupListByBlockID: {[key:string]: APIBackup},
}

const state: State = {
  list : [],
  deploymentList: [],
  listByRelease: {},
  projectListByRelease: {},
  backupListByBlockID: {},
  lastBackupListByBlockID: {}
}


const getters = { 
  getProjectListByRelease: (state:State) => {
    return (release:string) => {
      return state.projectListByRelease[release] || []
    }
  }, 
  getListByRelease: (state:State) => {
    return (release:string) => {
      return state.listByRelease[release] || []
    }
  },  
  getList: (state:State) => {
    return state.list
  },
  getBackupList: (state:State) => {
    return state.backupListByBlockID
  },
  getLastBackupList: (state:State) => {
    return state.lastBackupListByBlockID
  },
  getByID: (state:State) => {
    return (id:string) => {
      return state.list.find(blockAPI => blockAPI.id === id)
    }
  },
  getDeployements: (state:State) => {
    return state.deploymentList
  },
  getDeployementStatusByBlockID: (state:State) => {
    return (id:string) => {
      const block = state.list.find(blockAPI => blockAPI.id === id)
      if(block) {
        const deployment = state.deploymentList.find(dep => dep?.relationships?.subject?.data?.id === block.id )
        if(deployment) {
          return deployment.attributes.status
        }
      }
      return enums.DeploymentStatus.OFFLINE
    }
  },
  getByIDCategory: (state:State) => {
    return (id:string) => {
      return state.list.find(blockAPI => blockAPI?.relationships?.category?.data.id === id)
    }
  },      
}

const mutations = {
  EDIT_BLOCKAPI: (state:State, blockAPI:APIBlock) => {
    helpers.ressources.addMultipleRessourceToArray(state.list, [blockAPI])
  },
  SET_LIST: (state:State, blocksAPI:APIBlock[]) => {
    state.list = blocksAPI
  },
  SET_LIST_BY_RELASE: (state:State, payload:{blocks:APIBlock[], projects:APIProject[], release:string}) => {
    state.listByRelease[payload.release] = payload.blocks
    state.projectListByRelease[payload.release] = payload.projects
  },
  SET_DEPLOYMENT_LIST: (state:State, deployments:APIDeployment[]) => {
    state.deploymentList = deployments
  },
  ADD_DEPLOYMENTS: (state:State, deployments:APIDeployment[]) => {
    helpers.ressources.addMultipleRessourceToArray(state.deploymentList, deployments)
  },
  SET_LAST_BACKUP: (state:State, payload: {blockId:string, backup:APIBackup}) => {
    state.lastBackupListByBlockID[payload.blockId] = payload.backup
  },
  SET_BACKUPS: (state:State, payload: {blockId:string, backups:APIBackup[]}) => {
    state.backupListByBlockID[payload.blockId] = payload.backups.sort((a,b) => {
      return new Date(b.attributes.completed_at ?? 0).getTime() - new Date(a.attributes.completed_at ?? 0).getTime()
    })
  },
  DELETE_DEPLOYMENT: (state:State, deployment:APIDeployment) => {
    const index = state.deploymentList.findIndex((d:APIDeployment) => d.id === deployment.id)
    if(index >= 0) {
      state.deploymentList.splice(index,1)
    }  
  },
}

const actions = {
  addNode: (context:any, blockAPI:APIBlock) => {
    context.commit('EDIT_BLOCKAPI', blockAPI)
  },
  editBlock: (context:any, blockAPI:APIBlock) => {
    context.commit('EDIT_BLOCKAPI', blockAPI)
  },
  setBlockList: (context:any, blocksAPI:APIBlock[]) => {
    context.commit('SET_LIST', blocksAPI)
  },
  addDeployments: (context:any, deployments:APIDeployment[]) => {
    context.commit('ADD_DEPLOYMENTS', deployments)
  },
  deleteDeployment: (context:any, deployment:APIDeployment) => {
    context.commit('DELETE_DEPLOYMENT', deployment)
  },
  setDeploymentList: (context:any, deployments:APIDeployment[]) => {
    context.commit('SET_DEPLOYMENT_LIST', deployments)
  },
  fetchBlockListByRelease: (context:any, release:string) => {
    API.blocks.getListByRelease([release])
    .then(({blocks, projects}) => {
      context.commit('SET_LIST_BY_RELASE', {blocks,projects, release})
    })
  },
  fetchLastBackups: (context:any, blockIds:string[]) => {
    blockIds.forEach(blockId => {
      if(context.state.lastBackupListByBlockID[blockId]) return;
      API.blocks.getBackup(blockId, {per_page: '1', status: 'completed'})
      .then(({backups}) => {
        context.commit('SET_LAST_BACKUP', {blockId, backup: backups[0] ?? []})
      })
    })
  },
  fetchBlockBackups: (context:any, payload: { blockId:string, params:{ [key:string]: string } } ) => {
    context.commit('SET_BACKUPS', { blockId: payload.blockId, backups: [] })
    API.blocks.getBackup(payload.blockId, payload.params)
    .then(({backups}) => {
      context.commit('SET_BACKUPS', {blockId: payload.blockId, backups})
    })
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}